<div class="image-wrapper">
  <ng-container *ngIf="isLoading; else showImage">
    <div class="spinner"></div>
  </ng-container>

  <ng-template #showImage>
    <img
      *ngIf="imageSrc"
      [src]="imageSrc"
      [class.no-photo]="isFallback"
      alt="lazy image"
      decoding="async"
      loading="lazy"
    />
  </ng-template>
</div>